

import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { showModal } from "../../features/modal/modalSlice"
import Button from "../shared/Button"
import { resetStatusCode } from "../../features/admin/adminSlice"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { useEffect } from "react"
import ResultSuccessTickMark from "../shared/ResultSuccessTickMark"
import ResultErrorXMark from "../shared/ResultErrorXMark"
import { useScrollLock } from "../../hooks/useScrollLock"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 700px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 40px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        p{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-lg);
            color: ${({ theme }) => theme.mainTextColor};
            line-height: 30px;
            padding-bottom: 30px;
            text-align: center;
        }


    }
`

const SigortaTeklifAlResultModal = () => {

    const { modalLocation} = useSelector(state => state.modal)
    const dispatch = useDispatch()
    const location = useLocation()
    const { lockScroll, unlockScroll } = useScrollLock();


    useEffect(() => {
        const timer = setTimeout(() => {
                dispatch(showModal(null));
        }, 2500);
        return () => clearTimeout(timer);
      }, []);

         //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    
  return (
    <Container onClick={()=> showModal(null)}>
        <div className="modal" onClick={(e)=> e.stopPropagation()}>
            <p>Bizi tercih ettiğiniz için teşekkürler. En kısa içerisinde; size özel en uygun sigorta teklifleri hazırlanıp belirttiğiniz telefon numarasından aranacaksınız.</p>
            <Button type='button' text={"Tamam"} background={"#E85446"} color={"#fff"} handleClick={() => dispatch(showModal(null))} padding='0 10px' width='260px' />
        </div>
    </Container>
  )
}

export default SigortaTeklifAlResultModal